export enum ReferralStatuses {
    draft = 'draft',
    active = 'active',
    completed = 'completed'
}

export enum SharingOptions {
    email = 'email',
    whatsapp = 'whatsapp',
    copyLink = 'copyLink'
}
